import { Button, ChevronRightSVG, UndoSVG } from "@newsela/angelou";

import { withTrackEvent } from "@newsela/snitch";
import {
  IGuidedHighlightingQuestion,
  GUIDED_HIGHLIGHTING_QUESTION_STATUSES,
} from "@/view/utils/useGuidedHighlightingStudent/types";

import useGuidedHighlightingStudent from "@/view/utils/useGuidedHighlightingStudent";
import {
  buttonsWrapper,
  buttonCss,
} from "./GuidedHighlightingStudentSkillQuestion.style";

const ButtonWithTrackEvent = withTrackEvent(
  Button,
) as React.ForwardRefExoticComponent<
  React.ComponentProps<typeof Button> & React.RefAttributes<HTMLButtonElement>
>;

interface CompleteButtonProps {
  activeGuidedHighlightingQuestion: IGuidedHighlightingQuestion | undefined;
  handleCompleteActivity: () => void;
  handleNextQuestion: () => void;
  handleTryAgain: () => void;
}

const CompleteButtons = ({
  activeGuidedHighlightingQuestion,
  handleCompleteActivity,
  handleNextQuestion,
  handleTryAgain,
}: CompleteButtonProps) => {
  const { guidedHighlightingData } = useGuidedHighlightingStudent();
  const tryAgain =
    activeGuidedHighlightingQuestion?.status ===
    GUIDED_HIGHLIGHTING_QUESTION_STATUSES.tryAgain;
  const noMoreQuestions =
    guidedHighlightingData?.questions.filter(
      ({ status }) =>
        status === GUIDED_HIGHLIGHTING_QUESTION_STATUSES.completed,
    ).length === guidedHighlightingData?.questions?.length;

  let buttonLabel = "Next";
  let SvgComponent = ChevronRightSVG;
  let handleOnClick = handleNextQuestion;

  if (tryAgain) {
    handleOnClick = handleTryAgain;
    buttonLabel = "Try again";
    SvgComponent = UndoSVG;
  } else if (noMoreQuestions) {
    handleOnClick = handleCompleteActivity;
    buttonLabel = "Complete activity";
  }

  const eventPropertiesCheck = {
    objectType: "User",
    actionName: "Interact",
    event_type: "click",
    streamProperties: {
      component_type: "CompleteButton",
      description: `Perform the "${buttonLabel}" action for the active Guided Highlighting question. This action helps navigate the student to the next step or activity.`,
    },
  };

  const buttonIcon = {
    SvgComponent,
    alignment: Button.iconAlignments.right,
  };

  return (
    <div css={buttonsWrapper}>
      <ButtonWithTrackEvent
        __cssFor={{ root: buttonCss }}
        {...eventPropertiesCheck}
        icon={buttonIcon}
        flavor={Button.flavors.primary}
        disabled={!activeGuidedHighlightingQuestion}
        dataProps={{ "data-qa-selector": "Validate highlighted text" }}
        onClick={handleOnClick}
      >
        {buttonLabel}
      </ButtonWithTrackEvent>
    </div>
  );
};
export default CompleteButtons;
